import axios from 'axios';
const Confdata = window['runConfig'];

const AxiosInstance =  axios.create({ 
  baseURL: Confdata.apiUrl,
   timeout: 300000
});

export default AxiosInstance;

